import * as React from 'react'
import { PropsWithChildren, useContext, useState } from 'react'
import { GiveLivelyDonationForm } from '../components/give-lively-donation-form'
import PartialScreenModal from '../components/partial-screen-modal'
import { useModal } from '../utilities/react_hooks'

export const GiveLivelyContext = React.createContext<{
  donateTo: (organization: Queries.SanityOrganization, action_id: string) => void
}>({
  donateTo: () => {}
})

export const GiveLivelyProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [organization, setOrganization] = useState<Queries.SanityOrganization>()
  const [actionId, setActionId] = useState<string>()
  const { isOpen, openModal, closeModal } = useModal()

  const donateTo = React.useCallback(
    (organization: Queries.SanityOrganization, action_id: string) => {
      setOrganization(organization)
      setActionId(action_id)
      openModal()
    },
    []
  )

  const exitModal = React.useCallback(() => {
    closeModal()
    setTimeout(() => {
      setOrganization(null)
    }, 500)
  }, [organization])

  const value = React.useMemo(
    () => ({
      donateTo
    }),
    [donateTo]
  )

  return (
    <GiveLivelyContext.Provider value={value}>
      {children}

      <PartialScreenModal
        open={isOpen}
        onClose={exitModal}
        containerProps={{ sx: { flex: 1, maxHeight: 'calc(100vh - 124px)' } }}
      >
        {organization && actionId && (
          <GiveLivelyDonationForm organization={organization} actionId={actionId} />
        )}
      </PartialScreenModal>
    </GiveLivelyContext.Provider>
  )
}

export const giveLivelyState = () => useContext(GiveLivelyContext)
